import * as React from "react";
const VigoMobileLogo = props => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        style={{
            enableBackground: "new 0 0 1080 1080",
            maxWidth: "70px"
        }}
        viewBox="0 0 1080 1080"
        {...props}
    >
        <path d="M0 0h1080v1080H0z" />
        <path
            d="m540 615.89-125.51-339.3H241.51l208.84 526.82h179.3l208.84-526.82H665.51z"
            style={{
                fill: "#fff"
            }}
        />
    </svg>
);
export default VigoMobileLogo;
